export default __webpack_public_path__ + "static/media/NOKIA_HERE.a851e6f9.png";